import Cover from './cover';
import Img from './img';
import Text from './text';

Cover.Img = Img;
Cover.Text = Text;

export default Cover;
